export const BrandResearchRoutes = {
    brandResearch: '/brand-research',
} as const;
